import { actionOutskirtBuildingSelect } from "../features/info/outskirts/actionOutskirtsInfo";
import { actionModalOpen } from "../features/modals/actionModal";
import { IdModal } from "../features/modals/IdModal";
import { actionNotYetImplemented } from "../features/not-yet-implemented/actionNotYetImplemented";
import { actionThemedEventBuildingClicked } from "../features/themed-events/actionThemedEvent";
import { actionSelectTournamentDialog } from "../features/tournament-building/actionTournament";
import { actionWaterTowerSelect } from "../features/watertower/actionWaterTower";
import { IdOutskirtBuildings } from "./IdOutskirtBuildings";
export var mapOutskirtsOnClick = new Map([
    [IdOutskirtBuildings.Cafe, actionNotYetImplemented()],
    [IdOutskirtBuildings.Doghouse, actionModalOpen(IdModal.Doghouse)],
    [IdOutskirtBuildings.TournamentTent, actionSelectTournamentDialog()],
    [IdOutskirtBuildings.Watertower, actionWaterTowerSelect()],
    [IdOutskirtBuildings.Nursery, actionModalOpen(IdModal.Nursery)],
    [IdOutskirtBuildings.ThemedEvent, actionThemedEventBuildingClicked()],
    [IdOutskirtBuildings.Market, actionModalOpen(IdModal.Market)],
    [
        IdOutskirtBuildings.ExternalBarn,
        actionOutskirtBuildingSelect(IdOutskirtBuildings.ExternalBarn),
    ],
    [IdOutskirtBuildings.Library, actionNotYetImplemented()],
    [IdOutskirtBuildings.Pier, actionNotYetImplemented()],
    [IdOutskirtBuildings.Harbor, actionNotYetImplemented()],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapOutskirtsOnClick.tsx
// module id = 2152
// module chunks = 3